const $flexcarousel = $('#carousel');

if ($flexcarousel.length) {
  // The slider being synced must be initialized first

  $('#carousel').flexslider({
    animation: 'slide',
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 75,
    itemMargin: 29,
    move: 1,
    asNavFor: '#slider',
  });

  $('#slider').flexslider({
    animation: 'slide',
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: '#carousel',
  });
}
